export var ufoPlugin = function ufoPlugin() {
  return {
    name: 'ufo',
    pmPlugins: function pmPlugins() {
      var _process;
      var isSSR = Boolean((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
      if (isSSR) {
        // This plugin is not needed in SSR environments - and uses apis which are not available in SSR internally
        return [];
      }

      // This Plugin is not currently used as it leads to too high a level of abortions (due to the current TTAI timing being long, and users starting click before TTAI completes).
      // This can be reconsidered if we meaningfully reduce our TTAI (ie. <7 seconds)
      return [];

      // return [
      // 	{
      // 		name: 'traceUFOInteractionOnFirstInteraction',
      // 		plugin: traceUFOInteractionOnFirstInteraction,
      // 	},
      // ];
    }
  };
};